import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// `now` is passed in so a caller that has a server timestamp can count down against it (the
// disputes list does); callers without one pass the browser clock.
export const getTimeRemaining = (futureDateString: string, now: Dayjs): string => {
  const timeDiff = dayjs.utc(futureDateString).diff(now);

  if (timeDiff <= 0) {
    return 'expired';
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor(timeDiff / (1000 * 60));

  if (days > 0) {
    return `${days} day${days !== 1 ? 's' : ''} remaining`;
  } else if (hours > 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''} remaining`;
  } else {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} remaining`;
  }
};
